import { render, staticRenderFns } from "./ModalChangeBranchOffice.vue?vue&type=template&id=28ac8b44&scoped=true"
import script from "./ModalChangeBranchOffice.vue?vue&type=script&lang=js"
export * from "./ModalChangeBranchOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ac8b44",
  null
  
)

export default component.exports